import clsx from 'clsx';

import type { ColumnType } from '.';

export const getTdClassName = (
  column: ColumnType<any>,
  verticalAlign: string
) => {
  return clsx(
    'text-medium text-mainText',
    column.cellClassName,
    'transition-default',
    column.align === 'right' ? 'text-right' : 'text-left',
    verticalAlign === 'top' ? 'align-top' : 'align-middle'
  );
};
